(function () {
  "use strict";

  var cfg = window.wzTheme || {};
  var strings = cfg.strings || {};

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function stageOf(root) { return qs("[data-wz-stage]", root) || qs(".wz-gallery__stage img", root); }
  function formOf(root) { return qs("form[data-wz-form]", root) || qs(".wz-buy form[action*='/cart/add']", root); }

  function initProductForm() {
    var root = qs("[data-wz-product]");
    if (!root) return;

    var variantsEl = qs("[data-wz-variants]", root);
    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    }

    var idInput = qs("[data-wz-variant-id]", root);
    var planInput = qs("[data-wz-selling-plan]", root);
    var tiers = qs("[data-wz-tiers]", root);
    var modes = qs("[data-wz-mode]", root);

    var state = {
      variantId: idInput ? parseInt(idInput.value, 10) : null,
      planId: ""
    };

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    function activePricing(variant) {
      if (state.planId) {
        for (var i = 0; i < (variant.plans || []).length; i++) {
          if (String(variant.plans[i].id) === String(state.planId)) return variant.plans[i];
        }
      }
      return variant;
    }

    function find(sel) { return qs(sel, root) || qs(sel); }
    function flash(el, cls) {
      if (!el || el.hidden) return;
      el.classList.remove(cls);
      void el.offsetWidth;
      el.classList.add(cls);
      window.setTimeout(function () { el.classList.remove(cls); }, 700);
    }
    function setText(sel, value) {
      var el = find(sel);
      if (el && value !== undefined) el.textContent = value;
    }
    function setShown(sel, shown, value) {
      var el = find(sel);
      if (!el) return;
      el.hidden = !shown;
      if (shown && value !== undefined) el.textContent = value;
    }

    function updateMedia(variant) {
      if (!variant.mediaId) return;
      var thumb = qs('[data-wz-thumb][data-media-id="' + variant.mediaId + '"]', root);
      var stage = stageOf(root);
      if (!thumb || !stage) return;
      var src = thumb.getAttribute("data-src");
      if (!src || stage.getAttribute("src") === src) return;
      stage.style.opacity = 0;
      window.setTimeout(function () {
        stage.removeAttribute("srcset");
        stage.removeAttribute("sizes");
        stage.setAttribute("src", src);
        stage.setAttribute("alt", thumb.getAttribute("data-alt") || "");
        stage.style.opacity = 1;
      }, 180);
      qsa("[data-wz-thumb]", root).forEach(function (t) { t.classList.remove("wz-is-active"); });
      thumb.classList.add("wz-is-active");
    }

    function render() {
      var variant = findVariant(state.variantId);
      if (!variant) return;
      var pricing = activePricing(variant);

      if (idInput) idInput.value = variant.id;
      if (planInput) planInput.value = state.planId || "";

      setText("[data-wz-price]", pricing.priceMoney);
      setShown("[data-wz-was]", pricing.hasCompare, pricing.compareMoney);
      setShown("[data-wz-save]", pricing.hasCompare, pricing.saveMoney);
      setShown("[data-wz-perunit]", variant.hasUnits, pricing.unitMoney);
      setText("[data-wz-installment]", pricing.instalmentMoney);

      setText("[data-wz-sticky-name]", variant.title);
      setText("[data-wz-sticky-price]", pricing.priceMoney);
      setShown("[data-wz-sticky-was]", pricing.hasCompare, pricing.compareMoney);

      qsa("[data-wz-atc], [data-wz-sticky-atc]").forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? strings.addToCart : strings.soldOut;
      });

      updateMedia(variant);

      if (state.rendered) {
        flash(find("[data-wz-price]"), "wz-pop");
        flash(find("[data-wz-save]"), "wz-pop");
        flash(find("[data-wz-perunit]"), "wz-pop");
        var chosen = qs('[data-wz-tier="' + variant.id + '"]', root);
        flash(chosen, "wz-picked");
        flash(qs(".wz-tier__ship", chosen), "wz-pop");
      }
      state.rendered = true;

      var idx = 0;
      for (var vi = 0; vi < variants.length; vi++) {
        if (variants[vi].id === variant.id) { idx = vi + 1; break; }
      }
      document.dispatchEvent(new CustomEvent("wz:variant", {
        detail: { id: variant.id, index: idx, title: variant.title }
      }));

      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      } catch (err) {}

      if (idInput) idInput.dispatchEvent(new Event("change", { bubbles: true }));

      var payload = {
        id: variant.id,
        price: variant.price,
        title: variant.title,
        available: variant.available,
        featured_media: variant.mediaId ? { id: variant.mediaId } : null
      };
      ["variant:change", "variantChange", "product:variant-change"].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, {
          bubbles: true,
          detail: { variant: payload, sectionId: root.getAttribute("id") || "" }
        }));
      });
    }

    qsa("[data-wz-atc], [data-wz-sticky-atc]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!b.disabled) flash(b, "wz-fill");
      });
    });

    if (tiers) {
      tiers.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-wz-tier]");
        if (!btn || btn.disabled) return;
        qsa("[data-wz-tier]", tiers).forEach(function (b) {
          b.classList.remove("wz-is-selected");
          b.setAttribute("aria-checked", "false");
        });
        btn.classList.add("wz-is-selected");
        btn.setAttribute("aria-checked", "true");
        state.variantId = parseInt(btn.getAttribute("data-wz-tier"), 10);
        render();
      });
    }

    if (modes) {
      modes.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-wz-mode-btn]");
        if (!btn) return;
        qsa("[data-wz-mode-btn]", modes).forEach(function (b) {
          b.classList.remove("wz-is-active");
          b.setAttribute("aria-selected", "false");
        });
        btn.classList.add("wz-is-active");
        btn.setAttribute("aria-selected", "true");
        state.planId = btn.getAttribute("data-wz-mode-btn") || "";
        render();
      });
    }

    var thumbs = qs("[data-wz-thumbs]", root);
    if (thumbs) {
      thumbs.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-wz-thumb]");
        if (!btn) return;
        qsa("[data-wz-thumb]", thumbs).forEach(function (t) { t.classList.remove("wz-is-active"); });
        btn.classList.add("wz-is-active");
        var stage = stageOf(root);
        if (!stage) return;
        stage.style.opacity = 0;
        window.setTimeout(function () {
          stage.removeAttribute("srcset");
          stage.removeAttribute("sizes");
          stage.setAttribute("src", btn.getAttribute("data-src"));
          stage.setAttribute("alt", btn.getAttribute("data-alt") || "");
          stage.style.opacity = 1;
        }, 180);
      });
    }

    var form = formOf(root);
    if (form) {
      form.addEventListener("submit", function (e) {
        if (!cfg.cart || !document.querySelector("[data-wz-drawer]")) return;
        e.preventDefault();
        var button = form.querySelector("[data-wz-atc]");
        if (button) button.disabled = true;
        cfg.cart.add(new FormData(form)).then(function () {
          if (button) button.disabled = false;
        });
      });
      qsa("[data-wz-sticky-atc]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (form.requestSubmit) form.requestSubmit();
          else form.dispatchEvent(new Event("submit", { cancelable: true }));
        });
      });
    }

    render();
  }

  function initStickyBar() {
    var bar = qs("[data-wz-sticky]");
    var anchor = qs("[data-wz-sticky-anchor]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;

    var pastBuyBox = false;
    var atFooter = false;

    function apply() {
      var show = pastBuyBox && !atFooter;
      bar.classList.toggle("wz-is-visible", show);
      document.body.classList.toggle("wz-bar-on", show);
    }

    new IntersectionObserver(function (entries) {
      pastBuyBox = !entries[0].isIntersecting;
      apply();
    }, { rootMargin: "-80px 0px 0px 0px" }).observe(anchor);

    var footer = qs(".wz-footer") || qs("[data-wz-sticky-stop]");
    if (footer) {
      new IntersectionObserver(function (entries) {
        atFooter = entries[0].isIntersecting;
        apply();
      }, { rootMargin: "0px 0px -40px 0px", threshold: 0 }).observe(footer);
    }
  }

  var bundlesBound = false;
  function initBundleSections() {
    if (bundlesBound) return;
    bundlesBound = true;
    document.addEventListener("wz:variant", function (e) {
      var n = String(e.detail.index);
      qsa("[data-wz-bundle]").forEach(function (el) {
        var want = el.getAttribute("data-wz-bundle") || "all";
        el.hidden = !(want === "all" || want === n);
      });
    });
  }

  function start() {
    initBundleSections();
    initProductForm();
    initStickyBar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", start);
  document.addEventListener("shopify:block:select", function (e) {
    if (e.target && e.target.scrollIntoView) e.target.scrollIntoView({ block: "center", behavior: "smooth" });
  });
})();
